// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__4QvDx"};